import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (window.isSecureContext && 'serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then(registration => {
      console.log('Service Worker registrado para FCM:', registration);
    })
    .catch(error => {
      console.error('Error registrando el Service Worker:', error);
    });
} else {
  console.warn('Service Worker no disponible en este contexto');
}


// CRA performance tools (opcional)
reportWebVitals();
